export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'orders',
      displayName: 'menu.orders',
      meta: {
        iconClass: 'fa fa-shopping-cart',
      },
      disabled: false
    },
    {
      name: 'catalog',
      displayName: 'menu.catalog',
      meta: {
        iconClass: 'fa fa-cubes',
      },
      disabled: true,
      children: [
        {
          name: 'categories',
          displayName: 'menu.categories',
        },
        {
          name: 'products',
          displayName: 'menu.products',
        },
      ],
    },
    {
      name: 'payment-methods',
      displayName: 'menu.payment_methods',
      meta: {
        iconClass: 'fa fa-credit-card',
      },
    },
    {
      name: 'shipping-prices',
      displayName: 'menu.shipping-prices',
      meta: {
        iconClass: 'fa fa-truck',
      },
    },

  ],
}
